module.exports = __webpack_public_path__ + "static/media/58.86dddbf1.webp";